export class SejourSummary {
    constructor(gformSejour) {
        this.gform = gformSejour;
        this.wrapper = gformSejour.formWrapper;
    }

    update() {
        this.updateParticipants();
        this.updateAccommodation();
        this.updatePensions();
        this.updateTransfer();
        this.updateDiscount();
        this.updateTotals();
    }

    updateParticipants() {
        // Mise à jour des adultes
        const adultItems = this.wrapper.querySelectorAll('[data-summary="adults"]');
        const { adults, children } = this.gform.state;
        const adultPrice = this.gform.prices.adult;
        const childPrice = this.gform.prices.child;
        const adultsTotal = adults * adultPrice;
        const childrenTotal = children * childPrice;

        adultItems.forEach(item => {
            if (adults > 0) {
                item.classList.remove('gf-sejour-summary__item--hidden');
                const detailEl = item.querySelector('[data-detail]');
                const valueEl = item.querySelector('[data-value]');

                if (detailEl) detailEl.textContent = `${adults} x ${this.gform.formatPrice(adultPrice)}`;
                if (valueEl) valueEl.textContent = this.gform.formatPrice(adultsTotal);
            } else {
                item.classList.add('gf-sejour-summary__item--hidden');
            }
        });

        // Mise à jour des enfants
        const childItems = this.wrapper.querySelectorAll('[data-summary="children"]');
        childItems.forEach(item => {
            if (children > 0) {
                item.classList.remove('gf-sejour-summary__item--hidden');
                const detailEl = item.querySelector('[data-detail]');
                const valueEl = item.querySelector('[data-value]');

                if (detailEl) detailEl.textContent = `${children} x ${this.gform.formatPrice(childPrice)}`;
                if (valueEl) valueEl.textContent = this.gform.formatPrice(childrenTotal);
            } else {
                item.classList.add('gf-sejour-summary__item--hidden');
            }
        });
    }

    updateAccommodation() {
        const items = this.wrapper.querySelectorAll('[data-summary="accommodation"]');
        const { accommodation, accommodationPrice, adults, children } = this.gform.state;

        items.forEach(item => {
            if (accommodation && accommodation !== 'Aucun') {
                item.classList.remove('gf-sejour-summary__item--hidden');
                const nameEl = item.querySelector('[data-name]');
                const detailEl = item.querySelector('[data-detail]');
                const valueEl = item.querySelector('[data-value]');

                if (nameEl) nameEl.textContent = accommodation;

                if (accommodationPrice > 0) {
                    if (this.gform.isSejourSpecific) {
                        // Pour le formulaire spécifique : hébergement payant seulement pour les adultes
                        const totalPrice = accommodationPrice * adults;
                        if (detailEl) detailEl.textContent = `${adults} adulte(s) x ${this.gform.formatPrice(accommodationPrice)}`;
                        if (valueEl) valueEl.textContent = this.gform.formatPrice(totalPrice);
                    } else {
                        // Pour les autres formulaires : affichage normal
                        const totalParticipants = adults + children;
                        const totalPrice = accommodationPrice * totalParticipants;
                        if (detailEl) detailEl.textContent = `${totalParticipants} x ${this.gform.formatPrice(accommodationPrice)}`;
                        if (valueEl) valueEl.textContent = this.gform.formatPrice(totalPrice);
                    }
                } else {
                    if (detailEl) detailEl.textContent = '';
                    if (valueEl) valueEl.textContent = 'Inclus';
                }
            } else {
                item.classList.add('gf-sejour-summary__item--hidden');
            }
        });
    }

    updatePensions() {
        const adultItems = this.wrapper.querySelectorAll('[data-summary="pension-adult"]');
        const childItems = this.wrapper.querySelectorAll('[data-summary="pension-child"]');
        const { adultPensions, childPensions } = this.gform.state;
        const { adultPension: priceAdultPension, childPension: priceChildPension } = this.gform.prices;

        adultItems.forEach(item => {
            if (adultPensions > 0) {
                item.classList.remove('gf-sejour-summary__item--hidden');
                const detailEl = item.querySelector('[data-detail]');
                const valueEl = item.querySelector('[data-value]');

                if (detailEl) detailEl.textContent = `${adultPensions} x ${this.gform.formatPrice(priceAdultPension)}`;
                if (valueEl) valueEl.textContent = this.gform.formatPrice(adultPensions * priceAdultPension);
            } else {
                item.classList.add('gf-sejour-summary__item--hidden');
            }
        });

        childItems.forEach(item => {
            if (childPensions > 0) {
                item.classList.remove('gf-sejour-summary__item--hidden');
                const detailEl = item.querySelector('[data-detail]');
                const valueEl = item.querySelector('[data-value]');

                if (detailEl) detailEl.textContent = `${childPensions} x ${this.gform.formatPrice(priceChildPension)}`;
                if (valueEl) valueEl.textContent = this.gform.formatPrice(childPensions * priceChildPension);
            } else {
                item.classList.add('gf-sejour-summary__item--hidden');
            }
        });
    }

    updateTransfer() {
        const items = this.wrapper.querySelectorAll('[data-summary="transfer"]');
        const { transferCount } = this.gform.state;
        const transferPrice = this.gform.prices.transfer;
        const totalTransfer = transferCount * transferPrice;

        items.forEach(item => {
            if (transferCount > 0) {
                item.classList.remove('gf-sejour-summary__item--hidden');
                const detailEl = item.querySelector('[data-detail]');
                const valueEl = item.querySelector('[data-value]');
                if (detailEl) detailEl.textContent = `${transferCount} x ${this.gform.formatPrice(transferPrice)}`;
                if (valueEl) valueEl.textContent = this.gform.formatPrice(totalTransfer);
            } else {
                item.classList.add('gf-sejour-summary__item--hidden');
            }
        });
    }

    updateDiscount() {
        const items = this.wrapper.querySelectorAll('[data-summary="discount"]');
        const { discountAmount, discountName } = this.gform.state;

        items.forEach(item => {
            if (discountAmount > 0) {
                item.classList.remove('gf-sejour-summary__discount--hidden');
                const nameEl = item.querySelector('[data-discount-name]');
                const valueEl = item.querySelector('[data-discount-value]');

                if (nameEl) nameEl.textContent = discountName || 'Code promo';
                if (valueEl) valueEl.textContent = `-${this.gform.formatPrice(discountAmount)}`;
            } else {
                item.classList.add('gf-sejour-summary__discount--hidden');
            }
        });
    }

    updateTotals() {
        const subtotal = this.gform.calculateSubtotal();
        const total = this.gform.calculateTotal();
        const deposit = this.gform.calculateDeposit();

        const subtotalEls = this.wrapper.querySelectorAll('[data-subtotal]');
        const totalEls = this.wrapper.querySelectorAll('[data-total]');
        const depositEls = this.wrapper.querySelectorAll('[data-deposit]');

        subtotalEls.forEach(el => {
            el.textContent = this.gform.formatPrice(subtotal);
        });

        totalEls.forEach(el => {
            el.textContent = this.gform.formatPrice(total);
        });

        depositEls.forEach(el => {
            el.textContent = this.gform.formatPrice(deposit);
        });
    }
}
